export default function NotFoundText({
  children = "No records found",
  className = "",
}) {
  return (
    <div className={`text-dgray-500 text-center ${className}`}>{children}</div>
  );
}
